import * as React from 'react';
import { Col, Input } from 'reactstrap';
import FAIcon from '../fAIcon/FAIcon';
import './ItemEditableComponent.css';

export enum EditState {
    None,
    This,
    Other
}

export interface IItemEditableProps {
    editHandler: (entryId: number,value:string) => void;
    saveHandler: (listIndex: number, entryId: number) => void;
    cancelHandler: () => void;
    changeHandler: (editValue: string) => void;
    selectEntry: (listIndex: number, entryId: number,selectionMethod:string) => void;
    entryId: number;
    content: string;
    listIndex:number;
    editState: EditState;
    editValue: string | undefined;
}

export const ItemEditable = (props: IItemEditableProps) => {
    if (props.editState === EditState.None) {
        return (
            <Col md={4}>
                <div className="item">
                    {props.content}
                    <a className="iconButton" onClick={() => props.selectEntry(props.listIndex, props.entryId,'trash')}>
                        <FAIcon icon="trash" />
                    </a>
                    <a className="iconButton" onClick={() => props.editHandler(props.entryId, props.content)}>
                        <FAIcon icon="edit" />
                    </a>
                </div>
            </Col>
        );
    } else if (props.editState === EditState.This) {
        return (
            <Col md={4}>
                <div className="item editing">
                    <a
                        className="iconButton"
                        onClick={props.cancelHandler}
                    >
                        <FAIcon icon="times-circle" />
                    </a>
                    <a className="iconButton" onClick={() => props.saveHandler(props.listIndex, props.entryId)}>
                        <FAIcon icon="save" />
                    </a>
                    <Input value={props.editValue} onChange={e => props.changeHandler(e.currentTarget.value)} />
                </div>
            </Col>
        );
    } else {
        return (
            <Col md={4}>
                <div className="item">{props.content}</div>
            </Col>
        );
    }
};



// WEBPACK FOOTER //
// ./src/components/itemEditableComponent/ItemEditableComponent.tsx